import store from 'store'

/**
 * Workaround created for Menulog, the `je-trackDelivery-Capability` item gets set by OrderWeb
 * @returns {Boolean} when isDeliveryTracked is store value is 'true'
 */
const isDelcoOrder = () => {
  const deliveryTrackingValue = store.get('je-trackDelivery-Capability')
  const isDeliveryTracked =
    typeof deliveryTrackingValue === 'string'
      ? deliveryTrackingValue.replace(/[^A-Za-z]/g, '')
      : JSON.stringify(deliveryTrackingValue)

  return isDeliveryTracked === 'true'
}

export default isDelcoOrder
